import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const EvolutionChart = ({ data, title }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-[#1A1A1A] border border-white/15 rounded-lg p-3 shadow-xl">
          <p className="font-oranienbaum font-medium text-white/80 text-xs mb-2">
            {payload?.[0]?.payload?.period}
          </p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-xs font-oranienbaum" style={{ color: entry?.color }}>
              {entry?.name}: {entry?.dataKey === 'loncheados' ? entry?.value : `€${entry?.value?.toFixed(2)}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full h-52 md:h-60" aria-label={title || 'Evolución del periodo'}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#2A2A2A" />
          <XAxis
            dataKey="period"
            stroke="#555"
            tick={{ fontSize: 10, fontFamily: 'Oranienbaum, serif', fill: '#888' }}
          />
          <YAxis
            stroke="#555"
            tick={{ fontSize: 10, fontFamily: 'Oranienbaum, serif', fill: '#888' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            wrapperStyle={{ fontSize: '11px', fontFamily: 'Oranienbaum, serif', color: '#888' }}
            iconType="circle"
          />
          <Line type="monotone" dataKey="loncheados" stroke="#3A7F6B" strokeWidth={2} name="Loncheados" dot={{ fill: '#3A7F6B', r: 3 }} />
          <Line type="monotone" dataKey="salaries" stroke="#C9A24D" strokeWidth={2} name="€ Salarios" dot={{ fill: '#C9A24D', r: 3 }} />
          <Line type="monotone" dataKey="revenue" stroke="#8097D6" strokeWidth={2} name="€ Facturados" dot={{ fill: '#8097D6', r: 3 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EvolutionChart;